import PropTypes from 'prop-types';

import {
  LoadingDefaultProps,
  LoadingPropTypes,
} from '@/common/components/molecules/Loading/Loading.proptypes';
import { MEDIA_TYPES } from '@/common/constants';
import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';

export const ProductContainerDefaultProps = {
  path: null,
};

export const ProductContainerPropTypes = {
  path: PropTypes.string,
};

export const ProductDefaultProps = {
  ...DisabledDefaultProps,
  ...LoadingDefaultProps,
  agrementFgaz: null,
  brand: {},
  complementaryDescription: null,
  customerPrice: null,
  details: {},
  discountClasses: [],
  discountPrice: null,
  exclusivity: null,
  flags: [],
  getImageAlt: () => null,
  getImageSrc: () => null,
  getSlider: [],
  handleClickItem: () => null,
  handleCloseModal: () => null,
  id: null,
  invoiceUnit: null,
  isOpenModal: false,
  lengthName: false,
  links: {},
  manufacturerSku: null,
  name: null,
  publicPrice: null,
  range: null,
  sku: null,
  sliderModalSettings: {},
  sliderSettings: {},
  video: null,
  weeeAmount: null,
};

export const ProductPropTypes = {
  ...DisabledPropTypes,
  ...LoadingPropTypes,
  agrementFgaz: PropTypes.string,
  brand: PropTypes.shape({
    logo: PropTypes.shape({}),
    name: PropTypes.string,
  }),
  complementaryDescription: PropTypes.string,
  customerPrice: PropTypes.number,
  details: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.shape({})),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  discountClasses: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  ),
  discountPrice: PropTypes.number,
  exclusivity: PropTypes.string,
  flags: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string,
      slug: PropTypes.string,
    }),
  ),
  getImageAlt: PropTypes.func,
  getImageSrc: PropTypes.func,
  getSlider: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string,
      path: PropTypes.string,
      type: PropTypes.oneOf([MEDIA_TYPES.IMAGE, MEDIA_TYPES.VIDEO]),
      url: PropTypes.string,
    }),
  ),
  handleClickItem: PropTypes.func,
  handleCloseModal: PropTypes.func,
  id: PropTypes.string,
  invoiceUnit: PropTypes.string,
  isOpenModal: PropTypes.bool,
  lengthName: PropTypes.bool,
  links: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  manufacturerSku: PropTypes.string,
  name: PropTypes.string,
  publicPrice: PropTypes.number,
  range: PropTypes.string,
  sku: PropTypes.string,
  sliderModalSettings: PropTypes.shape({}),
  sliderSettings: PropTypes.shape({}),
  video: PropTypes.shape({
    alt: PropTypes.string,
    code: PropTypes.string,
    label: PropTypes.string,
    legend: PropTypes.string,
    path: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
  }),
  weeeAmount: PropTypes.number,
};
